import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const PublicFooter = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-gray-900 text-gray-400 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <h4 className="text-white font-semibold mb-4">{t('product')}</h4>
            <ul className="space-y-2">
              <li><a href="/#features" className="hover:text-white transition-colors">{t('features')}</a></li>
              <li><Link to="/pricing" className="hover:text-white transition-colors">{t('pricing')}</Link></li>
              <li><Link to="/templates" className="hover:text-white transition-colors">{t('templates')}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">{t('company')}</h4>
            <ul className="space-y-2">
              <li><a href="#" className="hover:text-white transition-colors">{t('about')}</a></li>
              <li><a href="#" className="hover:text-white transition-colors">{t('blog')}</a></li>
              <li><a href="#" className="hover:text-white transition-colors">{t('careers')}</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">{t('resources')}</h4>
            <ul className="space-y-2">
              <li><a href="#" className="hover:text-white transition-colors">{t('documentation')}</a></li>
              <li><a href="#" className="hover:text-white transition-colors">{t('helpCenter')}</a></li>
              <li><a href="#" className="hover:text-white transition-colors">{t('api')}</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">{t('legal')}</h4>
            <ul className="space-y-2">
              <li><Link to="/privacy" className="hover:text-white transition-colors">{t('privacy')}</Link></li>
              <li><Link to="/terms" className="hover:text-white transition-colors">{t('terms')}</Link></li>
              <li><Link to="/data-deletion" className="hover:text-white transition-colors">Data Deletion</Link></li>
              <li><Link to="/deauthorize" className="hover:text-white transition-colors">Disconnect Social Accounts</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p>&copy; 2026 ChatFlow. {t('allRightsReserved')}.</p>
            <p className="mt-2 md:mt-0">
              <a href="mailto:contact@chatflow.info" className="hover:text-white transition-colors">contact@chatflow.info</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
